<div style="text-align: center; margin-bottom: 8px;">
  <div class="inline-flex items-center gap-3 px-5 py-3 sm:px-7 sm:py-4"
    style="background: white; border: 2px solid #bbf7d0; border-radius: 14px; box-shadow: 0 1px 4px rgba(0,0,0,0.04);">
    <mat-icon style="color: #1C593D; font-size: 26px; width: 26px; height: 26px; flex-shrink: 0;">account_balance</mat-icon>
    <div style="text-align: left;">
      <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase; letter-spacing: 0.5px;">Saldo disponible</span>
      <p class="text-xl sm:text-2xl" style="margin: 2px 0 0; font-weight: 800; color: #1e5a3f;">
        ${{ actualBalance | currency:'':'' }} <span class="text-sm sm:text-base" style="font-weight: 600; color: #6b7280;">CLP</span>
      </p>
    </div>
  </div>
  <img *ngIf="!hasLoaded" src="assets/loader.svg" height="40" width="40" style="margin: 12px auto 0;" alt="">
</div>
